import { Component, OnInit } from '@angular/core';

import { EnvironmentService } from './environment-service/environment.service';
import { AdalService } from 'adal-angular4';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  env: string;

  constructor(
    environmentService: EnvironmentService,
    adalService: AdalService
  ) {
    adalService.init(environmentService.adalConfig);
  };

  ngOnInit() { }
  
}